import React from 'react';
import styles from './Image.module.scss';

export const BigImage = ({ src, alt }) => (
  <img className={styles.bigImage} alt={alt} src={src} />
);

export const SmallImage = ({ src, alt }) => (
  <img className={styles.smallImage} alt={alt} src={src} />
);
